<template>
    <v-container fluid>
        <v-row no-gutters class="d-block">
            <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                <v-card>
                    <v-card-title>
                        <v-row>

                            <v-col cols="6" sm="4" md="4" lg="2" xl="2">
                                <v-btn color="success" v-if="permisos[8]" small outlined @click="importacionNuevo()">
                                    <v-icon>upload</v-icon>
                                    Importar
                                </v-btn>
                            </v-col>

                            <v-col cols="6" sm="4" md="4" lg="2" xl="2">

                                <v-btn color="info" outlined small @click="importacionesGet()">
                                    <v-icon>refresh</v-icon>
                                    Refrescar
                                </v-btn>

                            </v-col>

                            <v-col cols="6" sm="4" md="4" lg="2" xl="2" class="pt-0">
                                <v-select
                                    hide-details
                                    v-model="filtros.unidad_operativa_id"
                                    :items="unidadesOperativas"
                                    item-text="unidad_operativa"
                                    item-value="unidad_operativa_id"
                                    @input="importacionesBuscar()"
                                />
                            </v-col>

                            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pt-0">
                                <v-text-field
                                    v-model="search"
                                    hide-details
                                    label="Buscar por Número, Archivo y pulse en el botón."
                                    clearable>
                                    <template v-slot:append>
                                        <v-btn
                                            color="secondary" small outlined
                                            @click="importacionesBuscar()">
                                            <v-icon>search</v-icon>
                                        </v-btn>
                                    </template>
                                    >
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" class="py-0 text-right">
                                <registros-conflicto endpoint="/importaciones/registros_conflicto" editable/>
                            </v-col>
                        </v-row>
                    </v-card-title>
                    <v-card-text>
                        <v-data-table
                            dense
                            class="elevation-3"
                            :headers="tableHeaders"
                            :items="importaciones"
                            :loading="loading"
                            item-key="importacion_id"
                            fixed-header
                            height="65vh"
                            :hide-default-footer="true"
                            disable-pagination
                        >
                            <template v-slot:item="{ item }">
                                <tr>
                                    <td class="text-left">{{ item.numero }}</td>
                                    <td class="text-left">{{ item.archivo_nombre }}</td>
                                    <td class="text-left text-no-wrap">
                                        <template v-if="item.registro_cantidad">
                                            {{ item.registro_desde }}
                                            <template v-if="item.registro_hasta !== item.registro_desde">– {{ item.registro_hasta }}</template>
                                            <span class="grey--text">({{ item.registro_cantidad }})</span>
                                            <v-icon x-small color="warning" v-if="!consecutivos(item)"
                                                    title="Los números de esta importación no son consecutivos: hay saltos dentro del rango.">
                                                linear_scale
                                            </v-icon>
                                        </template>
                                        <span v-else class="grey--text">—</span>
                                    </td>
                                    <td class="text-left">{{ item.nombres_apellidos }}</td>
                                    <td class="text-left">{{ item.fecha_crea | fechaESPHora }}</td>
                                    <td class="text-left" v-if="item.procesado">{{ item.fecha_actualiza | fechaESPHora }}</td>
                                    <td class="text-left" v-if="!item.procesado">
                                        <v-chip small color="warning" outlined>
                                            Sin Procesar
                                        </v-chip>
                                    </td>

                                    <td class="text-right">

                                        <v-btn  v-if="!item.procesado" color="success" small outlined @click="procesarData(item)"
                                                v-show="permisos[8]" class="mr-2">
                                            <v-icon>add_task</v-icon>
                                            A Procesar
                                        </v-btn>
                                        <v-btn v-if="!item.procesado" color="error" small outlined @click="cancelarAbrir(item)"
                                                v-show="permisos[8]" class="mr-2" title="Descartar esta importación sin procesarla">
                                            <v-icon>cancel</v-icon>
                                            Cancelar
                                        </v-btn>

                                        <v-btn v-if="item.procesado" color="info" small outlined @click="importacionVer(item)" class="mr-2">
                                            <v-icon>visibility</v-icon>
                                            Ver
                                        </v-btn>
                                        <v-btn color="secondary" small outlined @click="download(item)">
                                            <v-icon>download</v-icon>
                                            Descargar
                                        </v-btn>

                                    </td>
                                </tr>
                            </template>
                            <template v-slot:no-data>
                                <v-alert dense type="warning" outlined class="text-center mt-3">
                                    No existen registros.
                                </v-alert>
                            </template>

                        </v-data-table>
                        <Pagination :pagination="pagination" @setCambiarPagina="setCambiarPagina"
                                    v-if="pagination.total"/>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-dialog
            v-model="showModalProcesar"
            persistent
            fullscreen>
            <v-card>
                <v-card-title class="text-h5 pt-10">
                    Procesando los datos de la Importación, no cierre la ventana. Esto puede durar varios minutos,
                    espere a que termine el
                    proceso
                </v-card-title>

                <v-card-text>
                    <v-progress-linear
                        indeterminate
                        color="info"
                    ></v-progress-linear>
                </v-card-text>

            </v-card>

        </v-dialog>

        <v-dialog
            v-model="showModalGenerar"
            persistent
            max-width="520">
            <v-card>
                <v-card-title class="text-subtitle-1 font-weight-bold">
                    <v-icon left color="primary">key</v-icon>
                    Generando credenciales de estudiantes
                </v-card-title>

                <v-card-text>
                    <p class="mb-3">No cierre esta ventana. Se generan por lotes y lo avanzado queda guardado.</p>
                    <v-progress-linear
                        :indeterminate="!credenciales.total"
                        :value="credenciales.total ? (credenciales.generadas * 100) / credenciales.total : 0"
                        height="10" rounded
                        color="success"
                    ></v-progress-linear>
                    <div class="text-caption grey--text text--darken-1 mt-2" v-if="credenciales.total">
                        {{ credenciales.generadas }} de {{ credenciales.total }} · faltan {{ credenciales.pendientes }}
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- Cancelar una importación que aún no se procesa -->
        <v-dialog v-model="cancelar.dialogo" max-width="460">
            <v-card>
                <v-card-title class="text-subtitle-1 font-weight-bold">
                    <v-icon left color="error">cancel</v-icon> Cancelar importación
                </v-card-title>
                <v-card-text v-if="cancelar.importacion">
                    Se descartará la importación <b>{{ cancelar.importacion.numero }}</b>
                    ({{ cancelar.importacion.archivo_nombre }}) sin procesarla. No se creará ningún curso ni participante.
                    Podrá corregir el Excel y volver a importarlo.
                </v-card-text>
                <v-card-actions class="px-6 pb-4">
                    <v-spacer></v-spacer>
                    <v-btn text @click="cancelar.dialogo = false">Volver</v-btn>
                    <v-btn color="error" depressed :loading="cancelar.cargando" @click="cancelarConfirmar">Cancelar importación</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import Auth from "@/services/auth";
const Pagination = () => import("@/pages/Components/Pagination.vue");
import RegistrosConflicto from "@/components/Importaciones/RegistrosConflicto.vue";
import {generarCredencialesEstudiantes} from "@/services/credenciales";

export default {
    name: "AdministracionImportacionesLista",
    components: {Pagination, RegistrosConflicto},
    data() {
        return {
            permisos: [],
            cancelar: {dialogo: false, importacion: null, cargando: false},
            importaciones: [],
            unidadesOperativas: [],
            search: "",
            pagination: {},
            pageActual: 1,
            rowsPage: this.$store.state.arrayRowsPages[0],
            loading: false,
            showModalProcesar: false,
            showModalGenerar: false,
            credenciales: {generadas: 0, pendientes: 0, total: 0},
            tableHeaders: [
                {
                    text: 'Número',
                    value: 'numero',
                    align: 'left',
                    sortable: false,
                },
                {
                    text: 'Archivo',
                    value: 'archivo_nombre',
                    align: 'left',
                    sortable: false,
                },
                {
                    text: 'Registros (del – al)',
                    value: 'registro_desde',
                    align: 'left',
                    sortable: false,
                },
                {
                    text: 'Importado por',
                    value: 'nombres_apellidos',
                    align: 'left',
                    sortable: false,
                },
                {
                    text: 'Fecha importación',
                    value: 'fecha_crea',
                    align: 'left',
                    sortable: false,
                },
                {
                    text: 'Fecha procesado',
                    value: 'fecha_actualiza',
                    align: 'left',
                    sortable: false,
                },
                {
                    text: 'Acciones',
                    align: 'center',
                    sortable: false,
                },
            ],
            filtros: {
                unidad_operativa_id: null,
            }
        }
    },

    methods: {
        importacionNuevo() {
            this.$router.push({name: 'AdministracionImportacionesNuevo'});
        },
        importacionesGetFiltros() {

            window.axios.get('/importaciones/get_filtros', {}).then(async response => {
                if (response.data.success) {

                    this.unidadesOperativas = response.data.data.unidadesOperativas;

                    // Despues de asignar los filtros, vamos a traer los datos
                    await this.importacionesGet();

                } else if (response.data.success === false) {
                    this.$toast.error(response.data.message);
                }
            })
                .catch(error => {
                    console.log(error)
                    this.$toast.error("No se pudo listar datos.");
                })
                .finally(() => {
                })
        },
        importacionesBuscar() {
            this.pageActual = 1;
            this.importacionesGet();
        },
        importacionesGet() {
            this.loading = true;

            let params = {filtros: this.filtros, busqueda: this.search, page: this.pageActual, rowsPage: this.rowsPage};

            window.axios.get('/importaciones', {params}).then(response => {
                if (response.data.success) {

                    let data = response.data.data;
                    this.importaciones = data.importaciones.data;
                    this.pagination = data.pagination;

                } else if (response.data.success === false) {
                    this.$toast.error(response.data.message);
                }
            })
                .catch(error => {
                    console.log(error)
                    this.$toast.error("No se pudo listar datos.");
                })
                .finally(() => {
                    this.loading = false;
                })
        },
        download(importacion) {
            //url de descarga del back
            //let url_archivo = `${this.baseURLStorage}/${importacion.archivo_path}`
            //window.open(url_archivo);
            let importacion_id = importacion.importacion_id;
            let params = {importacion_id: importacion_id};
            //window.open(e);
            //console.log(`window.axios.get('${this.baseURLApi}/importaciones/descargar?importacion_id=${importacion_id}')`);
            //window.axios.get(`${this.baseURLApi}/importaciones/descargar?importacion_id=${importacion_id}`)
            let url = `${this.baseURLApi}/importaciones/descargar`;
            console.log('url:' + url);
            console.log('params:' + params);
            window.axios.get(url, {params})
            .then(
                response => {
                    if (response.data.success) {
                        // El API devuelve un enlace firmado temporal al archivo privado.
                        window.open(response.data.url);
                    } else if (response.data.success === false) {
                        this.$toast.error(response.data.message);
                    }
                }
            )
            .catch(
                error => {
                    console.log(error)
                    this.$toast.error("No se pudo descargar.");
                }
            )
            .finally(
                () => {
                this.loading = false;
                }
            );
        },
        importacionVer(importacion) {
            if (typeof importacion == "object") {
                let token = window.btoa(importacion.importacion_id);
                this.$router.push({name: 'AdministracionImportacionesVer', query: {token}});
            } else {
                this.$toast.error("Parametro no valido.");
            }
        },
        cancelarAbrir(importacion) {
            this.cancelar = {dialogo: true, importacion, cargando: false};
        },
        cancelarConfirmar() {
            this.cancelar.cargando = true;
            const datos = {importacion_id: this.cancelar.importacion.importacion_id, observacion: "Cancelada antes de procesar"};
            window.axios.post('/importaciones/delete', datos).then(response => {
                if (response.data.success) {
                    this.$toast.success("Importación cancelada.");
                    this.cancelar.dialogo = false;
                    this.importacionesGet();
                } else {
                    this.$toast.error(response.data.message, {timeout: 10000});
                }
            })
                .catch(error => {
                    const cuerpo = error.response && error.response.data;
                    this.$toast.error((cuerpo && cuerpo.message) || "No se pudo cancelar.", {timeout: 10000});
                })
                .finally(() => {
                    this.cancelar.cargando = false;
                });
        },
        procesarData(data) {
            this.showModalProcesar = true;

            window.axios.post('/importaciones/procesar', data).then(response => {
                if (response.data.success) {

                    this.$toast.success(response.data.message, {timeout: 12000});

                    // Los participantes nuevos reciben sus credenciales de una vez,
                    // sin depender de que alguien recuerde pulsar "Gen. Credenciales".
                    const datos = response.data.data || {};
                    if (datos.personas_nuevas) {
                        this.generarCredenciales(true);
                    }

                } else if (response.data.success === false) {
                    this.$toast.error(response.data.message, {
                        position: "top-center", timeout: false, closeButton: "button", icon: true,
                    });
                }
            })
                .catch(error => {
                    console.log(error)
                    this.$toast.error("No se pudo Procesar los datos.");
                })
                .finally(() => {
                    this.importacionesGet();
                    this.showModalProcesar = false;
                })
        },
        // El rango cubre exactamente tantos números como registros trae la importación.
        consecutivos(item) {
            return Number(item.registro_hasta) - Number(item.registro_desde) + 1 === Number(item.registro_cantidad);
        },
        async generarCredenciales(silencioso = false) {
            this.credenciales = {generadas: 0, pendientes: 0, total: 0};
            this.showModalGenerar = true;

            try {
                const resultado = await generarCredencialesEstudiantes(estado => {
                    this.credenciales = estado;
                });

                if (resultado.generadas) {
                    this.$toast.success(`Se generaron ${resultado.generadas} credenciales de estudiantes.`);
                } else if (!silencioso) {
                    this.$toast.info("Todos los estudiantes ya tienen credenciales.");
                }

                if (resultado.pendientes) {
                    this.$toast.warning(`Quedaron ${resultado.pendientes} pendientes. Pulse de nuevo Gen. Credenciales.`, {timeout: 15000});
                }

                if (resultado.conflictos.length) {
                    const ejemplos = resultado.conflictos.slice(0, 5).map(c => `${c.numero_identidad} (${c.nombre} ${c.apellido})`).join(", ");
                    this.$toast.warning(
                        `${resultado.conflictos.length} estudiantes no recibieron credenciales porque su identidad ya es el usuario de otra cuenta: ${ejemplos}.`,
                        {timeout: false, closeButton: "button"}
                    );
                }
            } catch (error) {
                console.log(error);
                const hechas = this.credenciales.generadas;
                this.$toast.error(
                    hechas
                        ? `Se interrumpió tras generar ${hechas} credenciales. Lo avanzado quedó guardado: pulse de nuevo para continuar.`
                        : "No se pudo generar las credenciales. Intente de nuevo.",
                    {timeout: 15000}
                );
            } finally {
                this.showModalGenerar = false;
            }
        },
        setCambiarPagina(data) {
            this.pageActual = data.page;
            this.rowsPage = data.rowsPage;
            this.importacionesGet();
        },
    },
    created() {
        Auth.checkPermisos(this.$route.path).then((res) => {
            this.permisos = res;
            this.importacionesGetFiltros();
        });

    }
}
</script>

<style>

</style>
